module.exports = __webpack_public_path__ + "media/images/pc/items/gift/gift_thanks_03-6b47f6838f178ddc0c9b930424545b68.jpg";